import { ValidationError } from "../errors";
import { serializerExtensions, SerializerExtensions } from "../extensions";
import { Serializer } from "../serializer";

export const integer: Serializer<number> & SerializerExtensions<number> = {
  serialize: (value) => {
    if (!Number.isInteger(value)) throw new ValidationError(`Value is not an integer (${value})`);
    return value;
  },
  deserialize: (raw) => {
    const value = parseInt(raw);

    if (isNaN(value)) throw new ValidationError(`Value cannot be converted to an integer (${raw})`);
    return value;
  },
  ...serializerExtensions(),
};
